class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverOpenTimer = null;
    this.hoverCloseTimer = null;

    this.mainDetailsToggle.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.mainDetailsToggle.addEventListener('pointerleave', this.onPointerLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  isDesktopMouse(event) {
    return window.innerWidth >= 990 && event.pointerType === 'mouse';
  }

  onPointerEnter(event) {
    if (!this.isDesktopMouse(event)) return;

    clearTimeout(this.hoverCloseTimer);
    clearTimeout(this.hoverOpenTimer);

    this.hoverOpenTimer = window.setTimeout(() => {
      const inlineMenu = this.closest('.header__inline-menu');
      inlineMenu?.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && typeof menu.close === 'function') menu.close();
      });

      this.openMenu();
    }, 90);
  }

  onPointerLeave(event) {
    if (!this.isDesktopMouse(event)) return;

    clearTimeout(this.hoverOpenTimer);
    clearTimeout(this.hoverCloseTimer);

    this.hoverCloseTimer = window.setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 320);
  }

  openMenu() {
    this.mainDetailsToggle.open = true;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }
}

customElements.define('header-menu', HeaderMenu);
